export function createsFixedContainingBlock(cs: CSSStyleDeclaration) {
  return (
    cs.transform !== "none" ||
    cs.perspective !== "none" ||
    cs.filter !== "none" ||
    cs.backdropFilter !== "none" ||
    cs.contain !== "none" ||
    cs.willChange.includes("transform") ||
    cs.position === "fixed"
  );
}
export function findFixedContainingBlock(
  el: HTMLElement | null
): HTMLElement | null {
  let n = el?.parentElement || null;
  while (n && n !== document.body) {
    if (createsFixedContainingBlock(getComputedStyle(n))) return n;
    n = n.parentElement;
  }
  return null;
}
export function findScrollContainer(
  el: HTMLElement | null
): HTMLElement | null {
  let n = el?.parentElement || null;
  while (n && n !== document.body) {
    const cs = getComputedStyle(n);
    const scrollsY =
      (cs.overflowY === "auto" || cs.overflowY === "scroll") &&
      n.scrollHeight > n.clientHeight;
    const scrollsX =
      (cs.overflowX === "auto" || cs.overflowX === "scroll") &&
      n.scrollWidth > n.clientWidth;
    if (scrollsY || scrollsX) return n;
    n = n.parentElement;
  }
  return null;
}
